/**
 * Evalutor for view condition "element_present"
 * @module
 */

var DocumentEnv = require('core/env/document');

/**
* @constant
* @type {string}
*/
var ELEMENT_PRESENT = 'element_present';

var pluginViewMatcherElement = {
  // Calling this "match" doesn't make any sense, except that that's the interface the View module is already using.
  match: function(viewTicket, condition) {
    return !!DocumentEnv.querySelector(condition.value);

    // TODO(TBD): Use querySelectorAll and check for require_visible if we decide to support that.
  },
};

module.exports = function(PluginManager) {
 PluginManager.registerViewMatcher(ELEMENT_PRESENT, pluginViewMatcherElement);
};

if (__TEST__) {
 module.exports.plugin = pluginViewMatcherElement;
}
